import { render, staticRenderFns } from "./TipoCargoComponent.vue?vue&type=template&id=693e5dbc&"
import script from "./TipoCargoComponent.vue?vue&type=script&lang=js&"
export * from "./TipoCargoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports